import React, { ChangeEvent, ReactNode, forwardRef } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { Radio } from '../Radio'

export interface IRadioOptionProps {
  id: string
  name: string
  value?: string
  selected?: boolean
  disabled?: boolean
  dataTest?: string
  className?: string
  children: ReactNode
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const useRadioOptionStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',

    /**
     * Adds a specific offset to align label text and button
     */
    '& .MuiRadio-root': {
      marginTop: -5,
    },
  },
}))

/**
 * RadioOption - allows for more flexible label content vs  that of Radio component
 */
export const RadioOption = forwardRef<HTMLLabelElement, IRadioOptionProps>(
  ({
    children,
    className: classNameProp = '',
    dataTest,
    disabled,
    id,
    name,
    onChange,
    selected,
    value,
  }) => {
    const classes = useRadioOptionStyles()
    return (
      <Radio
        className={classNames(classes.root, classNameProp)}
        name={name}
        onChange={onChange}
        dataTest={dataTest}
        checked={selected}
        value={value}
        id={id}
        disabled={disabled}
        label={children}
      />
    )
  }
)

export default RadioOption
